export default "__VITE_ASSET__f5fb2869__"